import { Api } from "./Api";

export const getExperienceList = async (search: string,sortOrder: string,statusFilter: string,page: any,limit: any) => {
  try {
    const queryParams = [];
    let url = `/experience`;
    if (search.trim() !== "") {
      queryParams.push(`name=${encodeURIComponent(search.trim())}`);
    }
    if (sortOrder !== "all") {
        queryParams.push(`type=${sortOrder}`);
      }
      if (statusFilter !== "all") {
        queryParams.push(`status=${statusFilter}`);
      }
      if (page) {
        queryParams.push(`page=${page}`);
      }
      if (limit) {
        queryParams.push(`limit=${limit}`);
      }
      
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }    const response = await Api.get(url,{
       
    });
    if (response.data && response.data.experiences) {
      return {
        experiences: response.data.experiences || [],
        totalExperiences: response.data.totalExperiences || 0,
        success: response.data.success,
        count: response.data.experiences.length,
        totalPage: response.data.totalPages
      };
    } else {
      console.error("Failed to fetch experience: No data found");
      return { experiences: [], totalExperiences: 0, success: false };
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 404) {
        console.warn("No experience found (404). Returning empty array.");
        return { experiences: [], totalExperiences: 0, success: false };
      } else {
        console.error("Error fetching experience:", error.response.data.message);
        return { error: error.response.data.message, experiences: [], totalExperiences: 0, success: false };
      }
    } else {
      console.error("Error fetching experience:", error.message);
      return { error: "An error occurred while trying to fetch experience", experiences: [], totalExperiences: 0, success: false };
    }
  }
};
export const addExperienceList = async (name: string,type: string,description: string) => {
    try {
      const response = await Api.post(
        `/experience`,
        { name,type,description },
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const EditExperienceList = async (id: any,name: string,type: string,description: string) => {
    try {
      const response = await Api.put(
        `/experience/${id}`,
        { name,type,description },
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const EditPage = async (id: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/page-setting/${id}`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getCountryList = async () => {
    try {
      const response = await Api.get(
        `/country/`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting country list:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting country list:', error.message);
        return { error: 'An error occurred while getting country list.' };
      }
    }
  };
  export const EditUserSegement = async (id: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/user-segment/${id}/${segId}`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating user segment:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating user segment:', error.message);
        return { error: 'An error occurred while updating user segment.' };
      }
    }
  };
  export const CreateUserSegement = async (id: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/user-segment/${id}`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating user segment:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating user segment:', error.message);
        return { error: 'An error occurred while updating user segment.' };
      }
    }
  };



  export const ExperienceStatusChange = async (payload: any) => {
    try {
      const response = await Api.post(
        `/experience/schedule`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const EditsetCookie = async (expId: any ,segId: any,cookieId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/cookie/${expId}/${segId}/${cookieId}`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating set Cookie:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating set Cookie:', error.message);
        return { error: 'An error occurred while updating set Cookie.' };
      }
    }
  };
  export const createsetCookie = async (expId: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/cookie/${expId}/${segId}`,
         payload,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating set Cookie:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating set Cookie:', error.message);
        return { error: 'An error occurred while updating set Cookie.' };
      }
    }
  };
  export const EditRunjsSetting = async (expId: any ,segId: any,runjsId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/run-js-setting/${expId}/${segId}/${runjsId}`,
         payload,
      );
      return response.data; 
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating Run js setting:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating Run js setting:', error.message);
        return { error: 'An error occurred while updating Run js setting.' };
      }
    }
  };
  export const CreateRunjsSetting = async (expId: any ,segId: any,payload: any) => {
    try {
      const response = await Api.post(`/experience/run-js-setting/${expId}/${segId}`, payload);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating Run js setting:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating Run js setting:', error.message);
        return { error: 'An error occurred while updating Run js setting.' };
      }
    }
  };
  export const getTemplateList = async (page = 1,
    limit = 10) => {
    try {
      let url = `/templates`;
      const response = await Api.get(url,{
        params: {
            page,
            limit,
        }
    });
      if (response.data && response.data.templates) {
        return {
          templates: response.data.templates || [],
          totalTemplates: response.data.totalTemplates || 0,
          success: response.data.success,
          count: response.data.templates.length,
          totalPage:response.data.totalPages
        };
      } else {
        console.error("Failed to fetch templates: No data found");
        return { templates: [], totalTemplates: 0, success: false };
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 404) {
          console.warn("No templates found (404). Returning empty array.");
          return { templates: [], totalTemplates: 0, success: false };
        } else {
          console.error("Error fetching templates:", error.response.data.message);
          return { error: error.response.data.message, templates: [], totalTemplates: 0, success: false };
        }
      } else {
        console.error("Error fetching templates:", error.message);
        return { error: "An error occurred while trying to fetch templates", templates: [], totalTemplates: 0, success: false };
      }
    }
  };
  export const editShowTemplates = async (expId: any,segId: any,tempId: any,payload: any) => {
    try {
      const response = await Api.post(`/experience/template/${expId}/${segId}/${tempId}`, payload);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating template:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating template:', error.message);
        return { error: 'An error occurred while updating template.' };
      }
    }
  };
  export const createShowTemplates = async (expId: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(`/experience/template/${expId}/${segId}`, payload);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating template:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating template:', error.message);
        return { error: 'An error occurred while updating template.' };
      }
    }
  };
  
  export const getExperienceData = async (id: any) => {
    try {
      const response = await Api.get(
        `/experience/${id}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getUserSegmentDetails = async (expId: any,segId:any) => {
    try {
      const response = await Api.get(
        `/experience/user-segment/${expId}/${segId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getPageDetails = async (id: any) => {
    try {
      const response = await Api.get(
        `/experience/page-setting/${id}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getCookiesData = async (expId: any,segId:any,cId: any) => {
    try {
      const response = await Api.get(
        `/experience/cookie/${expId}/${segId}/${cId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getRunjsData = async (expId: any,segId:any,runId: any) => {
    try {
      const response = await Api.get(
        `/experience/run-js-setting/${expId}/${segId}/${runId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getTemplateData = async (expId: any,segId:any,tempId: any) => {
    try {
      const response = await Api.get(
        `/experience/template/${expId}/${segId}/${tempId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const editViewPort = async (expId: any,segId: any,portId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/viewport-exit/${expId}/${segId}/${portId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating set Cookie:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating set Cookie:', error.message);
        return { error: 'An error occurred while updating set Cookie.' };
      }
    }
  };
  export const createViewPort = async (expId: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/viewport-exit/${expId}/${segId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating set Cookie:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating set Cookie:', error.message);
        return { error: 'An error occurred while updating set Cookie.' };
      }
    }
  };
  export const getViewExitPortData = async (expId: any,segId:any,viewExId: any) => {
    try {
      const response = await Api.get(
        `/experience/viewport-exit/${expId}/${segId}/${viewExId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const createPageMeter = async (expId: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/pageview-meter/${expId}/${segId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error creating page meter:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error creating page meter:', error.message);
        return { error: 'An error occurred while creating page meter.' };
      }
    }
  };
  export const editPageMeter = async (expId: any,segId: any,pmId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/pageview-meter/${expId}/${segId}/${pmId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating page meter:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating page meter:', error.message);
        return { error: 'An error occurred while updating page meter.' };
      }
    }
  };
  export const createMeterValue = async (expId: any,segId: any,meterId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/meter-value/${expId}/${segId}/${meterId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error creating Meter Value:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error creating Meter Value:', error.message);
        return { error: 'An error occurred while creating Meter Value.' };
      }
    }
  };
  export const editMeterValue = async (mId: any,payload: any) => {
    try {
      const response = await Api.put(
        `/experience/meter-value/${mId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating meter value:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating meter value:', error.message);
        return { error: 'An error occurred while updating meter value.' };
      }
    }
  };
  export const getPageMeterData = async (expId: any,segId:any,pagId: any) => {
    try {
      const response = await Api.get(
        `/experience/pageview-meter/${expId}/${segId}/${pagId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getMeterValueData = async (mId: any) => {
    try {
      const response = await Api.get(
        `/experience/meter-value/${mId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };
  export const getSchduleData = async (id: any) => {
    try {
      const response = await Api.get(
        `/experience/schedule/${id}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting data:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting data:', error.message);
        return { error: 'An error occurred while getting data.' };
      }
    }
  };
  export const copyExperience = async (expId: any) => {
    try {
      const response = await Api.post(`/experience/${expId}/copy`);
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error getting copying experience:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error getting copying experience:', error.message);
        return { error: 'An error occurred while getting copying experience.' };
      }
    }
  };
  export const createInteraction = async (expId: any,segId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/interaction/${expId}/${segId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error creating interaction:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error creating interaction:', error.message);
        return { error: 'An error occurred while creating interaction.' };
      }
    }
  };
  export const editInteraction = async (expId: any,segId: any,IntId: any,payload: any) => {
    try {
      const response = await Api.post(
        `/experience/interaction/${expId}/${segId}/${IntId}`,
         payload, 
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error updating interaction:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error updating interaction:', error.message);
        return { error: 'An error occurred while updating interaction.' };
      }
    }
  };
  export const getInteraction = async (expId: any,segId:any,intId: any) => {
    try {
      const response = await Api.get(
        `/experience/interaction/${expId}/${segId}/${intId}`,
      );
      return response.data;
    } catch (error: any) {
      if (error.response) {
        console.error('Error sending OTP:', error.response.data.message);
        return { error: error.response.data.message };
      } else {
        console.error('Error sending OTP:', error.message);
        return { error: 'An error occurred while sending OTP.' };
      }
    }
  };